import { motion } from "framer-motion";
import { ChevronDown, Play } from "lucide-react";

const heroBg =
  "https://images.unsplash.com/photo-1760172287483-02d382f63a6f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxibGFjayUyMGdvbGQlMjB0ZXh0dXJlfGVufDB8fHx8MTc5Mjk2MTkyNnww&ixlib=rb-4.1.0&q=85";

const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, delay: 0.15 * i, ease: "easeOut" },
  }),
};

export const Hero = () => (
  <header className="relative flex min-h-[100svh] items-center overflow-hidden">
    <img
      src={heroBg}
      alt=""
      aria-hidden="true"
      className="absolute inset-0 h-full w-full object-cover opacity-40"
    />
    <div className="absolute inset-0 bg-black/70" aria-hidden="true" />
    <div
      className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-[#080808] to-transparent"
      aria-hidden="true"
    />

    <div className="relative mx-auto w-full max-w-7xl px-6 py-24 lg:px-8">
      <motion.p
        variants={fadeUp}
        initial="hidden"
        animate="show"
        custom={0}
        className="mb-6 text-xs font-bold uppercase tracking-[0.35em] text-[#C9A45C] sm:text-sm"
        data-testid="hero-eyebrow"
      >
        Tempio Vivo — Fede in Azione
      </motion.p>

      <motion.h1
        variants={fadeUp}
        initial="hidden"
        animate="show"
        custom={1}
        data-testid="hero-headline"
        className="font-display max-w-4xl text-5xl font-semibold leading-[1.05] tracking-tight text-white sm:text-6xl lg:text-7xl"
      >
        Trasforma la tua vita
        <br />
        con <span className="text-[#C9A45C]">Dio al centro</span>.
      </motion.h1>

      <motion.p
        variants={fadeUp}
        initial="hidden"
        animate="show"
        custom={2}
        data-testid="hero-subtitle"
        className="mt-6 max-w-2xl text-lg font-medium text-white sm:text-xl"
      >
        Accendi la tua fede. Diventa saldo nella Parola. Affila la mente.
        Prepara il tuo corpo.
      </motion.p>

      <motion.p
        variants={fadeUp}
        initial="hidden"
        animate="show"
        custom={3}
        className="mt-5 max-w-2xl text-base leading-relaxed text-[#B8B8B8]"
      >
        Scopri il Metodo di Coaching Cristiano Tempio Vivo. Un ecosistema di
        formazione, strumenti quotidiani e relazioni cristiane per crescere
        nella fede, nella mente, nel corpo e nella famiglia.
      </motion.p>

      <motion.div
        variants={fadeUp}
        initial="hidden"
        animate="show"
        custom={4}
        className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center"
      >
        <a
          data-testid="hero-watch-video-button"
          href="#vsl"
          className="inline-flex items-center justify-center gap-2 rounded-sm border-2 border-[#C9A45C] bg-transparent px-8 py-4 text-xs font-bold uppercase tracking-widest text-[#C9A45C] transition-colors duration-300 hover:bg-[#C9A45C]/10 sm:text-sm"
        >
          <Play className="h-4 w-4" aria-hidden="true" />
          Guarda il video
        </a>
        <a
          data-testid="hero-discover-paths-button"
          href="#offerte"
          className="inline-flex items-center justify-center gap-2 rounded-sm bg-[#C9A45C] px-8 py-4 text-xs font-bold uppercase tracking-widest text-[#080808] transition-colors duration-300 hover:bg-[#E8D5A3] sm:text-sm"
        >
          Scopri i percorsi
        </a>
      </motion.div>

      <motion.p
        variants={fadeUp}
        initial="hidden"
        animate="show"
        custom={5}
        className="mt-12 text-xs uppercase tracking-[0.3em] text-[#8F7138]"
      >
        Fede • Fitness • Famiglia
      </motion.p>
    </div>

    <div
      className="absolute bottom-6 left-1/2 hidden -translate-x-1/2 text-[#C9A45C]/60 sm:block"
      aria-hidden="true"
    >
      <ChevronDown className="h-6 w-6 animate-bounce" />
    </div>
  </header>
);
